<template>
	<div class="patient-view response">
		<QuestionnaireCard :patient="patient">
		</QuestionnaireCard>
		<ChecklistCard :patient="patient">
		</ChecklistCard>
		<AppointmentCard :patient="patient" v-if="getUserType !== 'observer'">
		</AppointmentCard>
	</div>
</template>

<script>
import PatientView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'patient-response',
	extends: PatientView,
	computed: {
		...mapGetters(['getUserType'])
	}
}
</script>
